import { BhAdPopupComponentModule } from './../../components/bh-ad-popup/bh-ad-popup.component.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { TestingPromptPage } from './testing-prompt.page';

const routes: Routes = [
  {
    path: '',
    component: TestingPromptPage
  }
];

@NgModule({
  imports: [
    BhAdPopupComponentModule,
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [TestingPromptPage]
})
export class TestingPromptPageModule {}
